import Subheader from "client/common/components/layouts/Subheader";

import FetchErrorContainer, { FetchErrorContainerProps } from "./FetchErrorContainer";
import Page from "../layouts/Page";
import Body from "../layouts/Body";
import Button from "../buttons/Button";

import styles from "../../styles/FetchErrorPage.module.less";

type FetchErrorPageProps = FetchErrorContainerProps & {
  buttonText?: string;
  onButtonClick?: () => void;
};

const FetchErrorPage = ({
  buttonText = "Refresh Page",
  onButtonClick = () => window.location.reload(),
  ...rest
}: FetchErrorPageProps) => {
  return (
    <Page>
      <Subheader.Base>
        <FetchErrorContainer {...rest} />
      </Subheader.Base>
      <Body>
        <div className={styles.actions}>
          <Button onClick={onButtonClick}>{buttonText}</Button>
        </div>
      </Body>
    </Page>
  );
};

export default FetchErrorPage;
